import * as React from 'react';

/**
 * Helper function to create context and context consumer.
 * It also checks if we are in context or not - so we don't have to copy-paste code.
 */
function createContext(defaultValue) {
    var Context = React.createContext(undefined);
    function useContext(props) {
        var c = React.useContext(Context);
        var noThrow = props && props.noThrow;
        if (!c && !noThrow) {
            if (defaultValue)
                return defaultValue;
            throw new Error("useContext must be inside a Provider with a value");
        }
        return c;
    }
    return [useContext, Context.Provider];
}

export { createContext };
//# sourceMappingURL=createContext.esm.js.map
